// Datos mock para el módulo de facturación de El Salvador

// Clientes de prueba
export const clientes = [
  { id: 1, nombre: 'Juan Pérez', nit: '0614-250789-123-5', tipo: 'contribuyente' },
  { id: 2, nombre: 'María González', nit: '0000-000000-000-0', tipo: 'consumidor_final' },
  { id: 3, nombre: 'Carlos López', nit: '0614-180590-456-7', tipo: 'contribuyente' },
  { id: 4, nombre: 'Ana Martínez', nit: '0614-300885-789-1', tipo: 'contribuyente' },
  { id: 5, nombre: 'Pedro Ramírez', nit: '0000-000000-000-0', tipo: 'consumidor_final' },
  { id: 6, nombre: 'Laura Sánchez', nit: '0614-051295-234-8', tipo: 'contribuyente' },
  { id: 7, nombre: 'Roberto Díaz', nit: '0614-220782-567-9', tipo: 'contribuyente' },
  { id: 8, nombre: 'Sofia Torres', nit: '0000-000000-000-0', tipo: 'consumidor_final' },
];

// Proveedores de prueba
export const proveedores = [
  { id: 1, nombre: 'Distribuciones ABC, S.A. de C.V.', nit: '0614-123456-789-0' },
  { id: 2, nombre: 'Comercial XYZ, S.A. de C.V.', nit: '0614-987654-321-0' },
  { id: 3, nombre: 'Industrias Delta', nit: '0614-456789-123-0' },
  { id: 4, nombre: 'Mayorista Centro', nit: '0614-321654-987-0' },
  { id: 5, nombre: 'Proveedor Nacional', nit: '0614-654321-789-0' },
];

// Facturas de Consumidor Final (Ventas)
export const facturasCF = [
  { id: 1, serie: 'FCF', correlativo: '000001', fecha: '2026-03-01', cliente: 'María González', nit: '0000-000000-000-0', monto: 25.00, iva: 0, retencion: 0, total: 25.00, estado: 'emitida' },
  { id: 2, serie: 'FCF', correlativo: '000002', fecha: '2026-03-01', cliente: 'Pedro Ramírez', nit: '0000-000000-000-0', monto: 150.50, iva: 0, retencion: 0, total: 150.50, estado: 'emitida' },
  { id: 3, serie: 'FCF', correlativo: '000003', fecha: '2026-03-02', cliente: 'Sofia Torres', nit: '0000-000000-000-0', monto: 89.99, iva: 0, retencion: 0, total: 89.99, estado: 'emitida' },
  { id: 4, serie: 'FCF', correlativo: '000004', fecha: '2026-03-02', cliente: 'Cliente Ocasional', nit: '0000-000000-000-0', monto: 45.00, iva: 0, retencion: 0, total: 45.00, estado: 'anulada' },
  { id: 5, serie: 'FCF', correlativo: '000005', fecha: '2026-03-03', cliente: 'María González', nit: '0000-000000-000-0', monto: 67.50, iva: 0, retencion: 0, total: 67.50, estado: 'emitida' },
  { id: 6, serie: 'FCF', correlativo: '000006', fecha: '2026-03-03', cliente: 'Juan Pérez', nit: '0614-250789-123-5', monto: 112.00, iva: 0, retencion: 0, total: 112.00, estado: 'emitida' },
];

// Comprobantes de Crédito Fiscal (Ventas)
export const facturasCCF = [
  { id: 1, serie: 'CCF', correlativo: '000001', fecha: '2026-03-01', cliente: 'Juan Pérez', nit: '0614-250789-123-5', monto: 500.00, iva: 65.00, retencion: 0, total: 565.00, estado: 'emitida' },
  { id: 2, serie: 'CCF', correlativo: '000002', fecha: '2026-03-01', cliente: 'Carlos López', nit: '0614-180590-456-7', monto: 1250.00, iva: 162.50, retencion: 0, total: 1412.50, estado: 'emitida' },
  { id: 3, serie: 'CCF', correlativo: '000003', fecha: '2026-03-02', cliente: 'Ana Martínez', nit: '0614-300885-789-1', monto: 850.00, iva: 110.50, retencion: 0, total: 960.50, estado: 'emitida' },
  { id: 4, serie: 'CCF', correlativo: '000004', fecha: '2026-03-02', cliente: 'Laura Sánchez', nit: '0614-051295-234-8', monto: 2100.00, iva: 273.00, retencion: 0, total: 2373.00, estado: 'emitida' },
  { id: 5, serie: 'CCF', correlativo: '000005', fecha: '2026-03-03', cliente: 'Roberto Díaz', nit: '0614-220782-567-9', monto: 675.00, iva: 87.75, retencion: 0, total: 762.75, estado: 'anulada' },
  { id: 6, serie: 'CCF', correlativo: '000006', fecha: '2026-03-03', cliente: 'Juan Pérez', nit: '0614-250789-123-5', monto: 320.00, iva: 41.60, retencion: 0, total: 361.60, estado: 'emitida' },
];

// Comprobantes de Retención
export const retenciones = [
  { id: 1, serie: 'RET', correlativo: '000001', fecha: '2026-03-01', cliente: 'Carlos López', nit: '0614-180590-456-7', monto: 1250.00, iva: 162.50, retencion: 10, total: 1412.50, estado: 'emitida' },
  { id: 2, serie: 'RET', correlativo: '000002', fecha: '2026-03-02', cliente: 'Ana Martínez', nit: '0614-300885-789-1', monto: 850.00, iva: 110.50, retencion: 10, total: 960.50, estado: 'emitida' },
  { id: 3, serie: 'RET', correlativo: '000003', fecha: '2026-03-03', cliente: 'Laura Sánchez', nit: '0614-051295-234-8', monto: 2100.00, iva: 273.00, retencion: 10, total: 2373.00, estado: 'emitida' },
];

// Sujetos Excluidos
export const sujetosExcluidos = [
  { id: 1, serie: 'SE', correlativo: '000001', fecha: '2026-03-01', cliente: 'Ministerio de Hacienda', nit: '0614-000001-000-0', monto: 5000.00, iva: 0, retencion: 0, total: 5000.00, estado: 'emitida' },
  { id: 2, serie: 'SE', correlativo: '000002', fecha: '2026-03-02', cliente: 'Gobierno Local', nit: '0614-000002-000-0', monto: 2500.00, iva: 0, retencion: 0, total: 2500.00, estado: 'emitida' },
  { id: 3, serie: 'SE', correlativo: '000003', fecha: '2026-03-03', cliente: 'Institución Pública', nit: '0614-000003-000-0', monto: 1500.00, iva: 0, retencion: 0, total: 1500.00, estado: 'emitida' },
];

// Notas de Crédito
export const notasCredito = [
  { id: 1, serie: 'NC', correlativo: '000001', fecha: '2026-03-01', cliente: 'Juan Pérez', nit: '0614-250789-123-5', motivo: 'Devolución de mercancía', monto: 100.00, iva: 13.00, total: 113.00, documentoAfectado: 'CCF-000001', estado: 'emitida' },
  { id: 2, serie: 'NC', correlativo: '000002', fecha: '2026-03-02', cliente: 'Carlos López', nit: '0614-180590-456-7', motivo: 'Descuento comercial', monto: 250.00, iva: 32.50, total: 282.50, documentoAfectado: 'CCF-000002', estado: 'emitida' },
  { id: 3, serie: 'NC', correlativo: '000003', fecha: '2026-03-03', cliente: 'Ana Martínez', nit: '0614-300885-789-1', motivo: 'Error en factura', monto: 170.00, iva: 22.10, total: 192.10, documentoAfectado: 'CCF-000003', estado: 'anulada' },
];

// Notas de Débito
export const notasDebito = [
  { id: 1, serie: 'ND', correlativo: '000001', fecha: '2026-03-01', cliente: 'Juan Pérez', nit: '0614-250789-123-5', motivo: 'Cargo por transporte', monto: 50.00, iva: 6.50, total: 56.50, documentoAfectado: 'CCF-000001', estado: 'emitida' },
  { id: 2, serie: 'ND', correlativo: '000002', fecha: '2026-03-02', cliente: 'Laura Sánchez', nit: '0614-051295-234-8', motivo: 'Interés por mora', monto: 100.00, iva: 13.00, total: 113.00, documentoAfectado: 'CCF-000004', estado: 'emitida' },
];

// Compras Consumidor Final
export const comprasCF = [
  { id: 1, serie: 'CCF-C', correlativo: '000001', fecha: '2026-03-01', proveedor: 'Tienda Local', nit: '0614-111111-111-1', monto: 75.00, iva: 0, retencion: 0, total: 75.00, estado: 'recibida' },
  { id: 2, serie: 'CCF-C', correlativo: '000002', fecha: '2026-03-02', proveedor: 'Mercado Municipal', nit: '0614-222222-222-2', monto: 45.50, iva: 0, retencion: 0, total: 45.50, estado: 'recibida' },
  { id: 3, serie: 'CCF-C', correlativo: '000003', fecha: '2026-03-03', proveedor: 'Proveedor minorista', nit: '0614-333333-333-3', monto: 120.00, iva: 0, retencion: 0, total: 120.00, estado: 'recibida' },
];

// Compras Crédito Fiscal
export const comprasCCF = [
  { id: 1, serie: 'CCF-P', correlativo: '000001', fecha: '2026-03-01', proveedor: 'Distribuciones ABC, S.A. de C.V.', nit: '0614-123456-789-0', monto: 2500.00, iva: 325.00, retencion: 0, total: 2825.00, estado: 'recibida' },
  { id: 2, serie: 'CCF-P', correlativo: '000002', fecha: '2026-03-01', proveedor: 'Comercial XYZ, S.A. de C.V.', nit: '0614-987654-321-0', monto: 1800.00, iva: 234.00, retencion: 0, total: 2034.00, estado: 'recibida' },
  { id: 3, serie: 'CCF-P', correlativo: '000003', fecha: '2026-03-02', proveedor: 'Industrias Delta', nit: '0614-456789-123-0', monto: 3200.00, iva: 416.00, retencion: 0, total: 3616.00, estado: 'recibida' },
  { id: 4, serie: 'CCF-P', correlativo: '000004', fecha: '2026-03-02', proveedor: 'Mayorista Centro', nit: '0614-321654-987-0', monto: 950.00, iva: 123.50, retencion: 0, total: 1073.50, estado: 'recibida' },
  { id: 5, serie: 'CCF-P', correlativo: '000005', fecha: '2026-03-03', proveedor: 'Proveedor Nacional', nit: '0614-654321-789-0', monto: 4200.00, iva: 546.00, retencion: 0, total: 4746.00, estado: 'recibida' },
];

// Datos para Libro de Compras
export const libroCompras = [
  { fecha: '2026-03-01', documento: 'CCF-P-000001', proveedor: 'Distribuciones ABC', nit: '0614-123456-789-0', compras: 2500.00, iva: 325.00, total: 2825.00 },
  { fecha: '2026-03-01', documento: 'CCF-P-000002', proveedor: 'Comercial XYZ', nit: '0614-987654-321-0', compras: 1800.00, iva: 234.00, total: 2034.00 },
  { fecha: '2026-03-02', documento: 'CCF-P-000003', proveedor: 'Industrias Delta', nit: '0614-456789-123-0', compras: 3200.00, iva: 416.00, total: 3616.00 },
  { fecha: '2026-03-02', documento: 'CCF-P-000004', proveedor: 'Mayorista Centro', nit: '0614-321654-987-0', compras: 950.00, iva: 123.50, total: 1073.50 },
  { fecha: '2026-03-03', documento: 'CCF-P-000005', proveedor: 'Proveedor Nacional', nit: '0614-654321-789-0', compras: 4200.00, iva: 546.00, total: 4746.00 },
];

// Datos para Libro de Ventas CF
export const libroVentasCF = [
  { fecha: '2026-03-01', documento: 'FCF-000001', cliente: 'María González', nit: '0000-000000-000-0', ventas: 25.00, iva: 0, total: 25.00 },
  { fecha: '2026-03-01', documento: 'FCF-000002', cliente: 'Pedro Ramírez', nit: '0000-000000-000-0', ventas: 150.50, iva: 0, total: 150.50 },
  { fecha: '2026-03-02', documento: 'FCF-000003', cliente: 'Sofia Torres', nit: '0000-000000-000-0', ventas: 89.99, iva: 0, total: 89.99 },
  { fecha: '2026-03-02', documento: 'FCF-000004', cliente: 'Cliente Ocasional', nit: '0000-000000-000-0', ventas: 45.00, iva: 0, total: 45.00 },
  { fecha: '2026-03-03', documento: 'FCF-000005', cliente: 'María González', nit: '0000-000000-000-0', ventas: 67.50, iva: 0, total: 67.50 },
];

// Datos para Libro de Ventas CCF
export const libroVentasCCF = [
  { fecha: '2026-03-01', documento: 'CCF-000001', cliente: 'Juan Pérez', nit: '0614-250789-123-5', ventas: 500.00, iva: 65.00, total: 565.00 },
  { fecha: '2026-03-01', documento: 'CCF-000002', cliente: 'Carlos López', nit: '0614-180590-456-7', ventas: 1250.00, iva: 162.50, total: 1412.50 },
  { fecha: '2026-03-02', documento: 'CCF-000003', cliente: 'Ana Martínez', nit: '0614-300885-789-1', ventas: 850.00, iva: 110.50, total: 960.50 },
  { fecha: '2026-03-02', documento: 'CCF-000004', cliente: 'Laura Sánchez', nit: '0614-051295-234-8', ventas: 2100.00, iva: 273.00, total: 2373.00 },
  { fecha: '2026-03-03', documento: 'CCF-000006', cliente: 'Juan Pérez', nit: '0614-250789-123-5', ventas: 320.00, iva: 41.60, total: 361.60 },
];

// Datos para Libro Diario
export const libroDiario = [
  { fecha: '2026-03-01', concepto: 'Venta de mercancía - CCF-000001', debe: 565.00, haber: 0, cuenta: 'Cuentas por Cobrar' },
  { fecha: '2026-03-01', concepto: 'Venta de mercancía - CCF-000001', debe: 0, haber: 500.00, cuenta: 'Ventas' },
  { fecha: '2026-03-01', concepto: 'Venta de mercancía - CCF-000001', debe: 0, haber: 65.00, cuenta: 'IVA Debitable' },
  { fecha: '2026-03-01', concepto: 'Compra mercancía - CCF-P-000001', debe: 2500.00, haber: 0, cuenta: 'Inventario' },
  { fecha: '2026-03-01', concepto: 'Compra mercancía - CCF-P-000001', debe: 325.00, haber: 0, cuenta: 'IVA Crédito Fiscal' },
  { fecha: '2026-03-01', concepto: 'Compra mercancía - CCF-P-000001', debe: 0, haber: 2825.00, cuenta: 'Cuentas por Pagar' },
];

// Datos para Libro Mayor
export const libroMayor = [
  { cuenta: 'Caja', saldoInicial: 5000.00, debe: 3500.00, haber: 2100.00, saldoFinal: 6400.00 },
  { cuenta: 'Bancos', saldoInicial: 15000.00, debe: 5000.00, haber: 3000.00, saldoFinal: 17000.00 },
  { cuenta: 'Cuentas por Cobrar', saldoInicial: 8000.00, debe: 565.00, haber: 0, saldoFinal: 8565.00 },
  { cuenta: 'Inventario', saldoInicial: 25000.00, debe: 2500.00, haber: 0, saldoFinal: 27500.00 },
  { cuenta: 'Proveedores', saldoInicial: 12000.00, debe: 0, haber: 2825.00, saldoFinal: 14825.00 },
  { cuenta: 'Capital', saldoInicial: 30000.00, debe: 0, haber: 0, saldoFinal: 30000.00 },
];

// Estados financieros
export const estadosFinancieros = {
  balance: {
    activos: { corriente: 42000, noCorriente: 50000, total: 92000 },
    pasivos: { corriente: 25000, noCorriente: 10000, total: 35000 },
    patrimonio: { capital: 30000, reservas: 15000, resultados: 12000, total: 57000 },
  },
  estadoResultados: {
    ventas: 15000,
    costoVentas: 9000,
    utilidadBruta: 6000,
    gastosOperacion: 2500,
    utilidadOperacion: 3500,
    otrosGastos: 500,
    utilidadAntesImpuestos: 3000,
    impuestos: 450,
    utilidadNeta: 2550,
  },
};

// Reporte F07 - IVA
export const reporteIVA = {
  periodo: 'Marzo 2026',
  ivaDebitable: { compras: 1645.00, importaciones: 0, total: 1645.00 },
  ivaCreditable: { ventas: 760.10, notasCredito: 0, total: 760.10 },
  diferencia: 884.90,
  activo: true,
};

// Reporte F11 - Renta
export const reporteRenta = {
  periodo: '2025',
  ingresos: { ventas: 180000, otros: 5000, total: 185000 },
  costos: { inventarioInicial: 50000, compras: 80000, inventarioFinal: 45000, total: 85000 },
  gastos: { salaries: 35000, servicios: 8000, depreciacion: 5000, otros: 7000, total: 55000 },
  rentaImponible: 45000,
  impuesto: 11250,
};

// Reporte F14 - Persona natural
export const reportePCTA = {
  periodo: 'Marzo 2026',
  compras: [
    { proveedor: 'Distribuciones ABC', nit: '0614-123456-789-0', monto: 2825.00 },
    { proveedor: 'Comercial XYZ', nit: '0614-987654-321-0', monto: 2034.00 },
  ],
  totalCompras: 14594.50,
  sujetoExcluido: false,
};

// Función para obtener documentos según tipo
export const getDocumentos = (tipo) => {
  switch (tipo) {
    case 'factura-cf': return facturasCF;
    case 'factura-ccf': return facturasCCF;
    case 'retencion': return retenciones;
    case 'sujeto-excluido': return sujetosExcluidos;
    case 'nota-credito': return notasCredito;
    case 'nota-debito': return notasDebito;
    case 'compra-cf': return comprasCF;
    case 'compra-ccf': return comprasCCF;
    default: return [];
  }
};
